import { render, staticRenderFns } from "./coinRecord.vue?vue&type=template&id=f9ca3baa&scoped=true&"
import script from "./coinRecord.vue?vue&type=script&lang=js&"
export * from "./coinRecord.vue?vue&type=script&lang=js&"
import style0 from "./coinRecord.vue?vue&type=style&index=0&id=f9ca3baa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ca3baa",
  null
  
)

export default component.exports